import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import MainPageHeaderRight from './MainPageHeaderRight';
import MobileHeaderActions from './MobileHeaderActions';
import { useNavigate } from 'react-router-dom';
import useDarkMode from '../../../hooks/useDarkMode';
import LogoIcon from '../../../assets/img/website/logo-icon.png';

const MainPageHeader = () => {
	const navigate = useNavigate();
	const { darkModeStatus } = useDarkMode();
	return (
		<Header mobileEnd={<MobileHeaderActions />}>
			<HeaderLeft>
				<div
					className='col d-flex align-items-center'
					style={{ cursor: 'pointer', gap: 8 }}
					onClick={() => navigate('/')}>
					<img
						src={LogoIcon}
						alt='StoriesVillage'
						style={{ height: 36, width: 36, objectFit: 'contain' }}
					/>
					<span
						style={{
							fontFamily: "'Baloo 2', cursive",
							fontSize: '1.4rem',
							fontWeight: 700,
							letterSpacing: -0.5,
							lineHeight: 1,
						}}>
						<span style={{ color: 'var(--bs-primary)' }}>Stories</span>
						<span style={{ color: darkModeStatus ? '#fff' : '#2d3436' }}>Village</span>
					</span>
				</div>
			</HeaderLeft>
			<MainPageHeaderRight/>
		</Header>
	);
};

export default MainPageHeader;
